module.exports = __webpack_public_path__ + "img/IMG_8024-1200w.fb8daf90.jpg";